import React, { createContext, useCallback, useContext, useState } from 'react';
import { IUser } from './auth';

interface DeviceContextData {
  selectedUser: IUser;
  selectedDeviceId: string;
  selectedSensorId: string;
  selectedIndicator: string;
  selectDevice(data: string): Promise<void>;
  selectSensor(data: string): Promise<void>;
  selectUser(user: IUser): Promise<void>;
  selectIndicator(data: string): Promise<void>;
}

const SelectInfoContext = createContext<DeviceContextData>({} as DeviceContextData);

const SelectInfoProvider: React.FC = ({ children }) => {
  const [selectedSensorId, setSelectedSensorId] = useState(() => {
    return '';
  });

  const [selectedDeviceId, setSelectedDeviceId] = useState(() => {
    return '';
  });

  const [selectedUser, setSelectedUser] = useState<IUser>(() => {
    return {} as IUser;
  });

  const [selectedIndicator, setSelectedIndicator] = useState(() => {
    return '';
  });

  const selectSensor = useCallback(async (sensorId: string) => {
    setSelectedSensorId(sensorId);
  }, []);

  const selectDevice = useCallback(async (deviceId: string) => {
    setSelectedDeviceId(deviceId);
  }, []);

  const selectUser = useCallback(async (selectuser: IUser) => {
    setSelectedUser(selectuser);
  }, []);

  const selectIndicator = useCallback(async (indicatorId: string) => {
    setSelectedIndicator(indicatorId);
  }, []);
  return (
    <SelectInfoContext.Provider
      value={{
        selectedUser,
        selectedDeviceId,
        selectedSensorId,
        selectedIndicator,
        selectDevice,
        selectUser,
        selectSensor,
        selectIndicator
      }}
    >
      {children}
    </SelectInfoContext.Provider>
  );
};

function useSelectInfo(): DeviceContextData {
  const context = useContext(SelectInfoContext);

  if (!context) {
    throw new Error('useDevice must be used within a DeviceProvider');
  }

  return context;
}

export { SelectInfoProvider, useSelectInfo };

